<div style="margin: 0 7px;">
  <h4 style="padding: 0 15px;">Home</h4>
  <div>
    <img src="assets/img/mock-ups/controversy-home-pg.png" height="100%" width="100%" class="img-wrapper">
  </div>
</div>
